import api from '../index';

export const GetCountryListApi = () => api.post('countrycode');
